<template>
  <el-container
    id="container-work-editor"
    class="is-vertical"
    style="height: 100%; width: 100%; position: fixed;">
    <top-header>
      <template slot="left">
        <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: '/work' }">作品集列表</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" :element-loading-text="loadingHint">
        <work-form-content :form="form" style="margin-top: 80px;" />

        <p class="auto-save-hint">{{autoSaveHint}}</p>

        <el-switch
          v-model="form.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>

        <el-button type="primary" class="btn-upload" size="mini" @click="submit">
          送出
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/components/LeftMenu.vue'
import TopHeader from '@/components/TopHeader.vue'
import WorkFormContent from '@/components/work/WorkEditorForm.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'

export default {
  mixins: [MixinOfPreventLeaveEditPage],
  components: {
    LeftMenu,
    TopHeader,
    WorkFormContent
  },
  data () {
    return {
      oriObj: {},
      form: {
        Title: '',
        IsActive: true
      },
      isLoading: false,
      loadingHint: '',
      autoSaveTimer: null,
      hasChangeNotSaveYet: false,
      lastSaveTs: null,
      notification: null
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createWork'
    },
    title () {
      return this.isEdit ? this.form.Title : '新增'
    },
    cacheKey () {
      return 'cache-work-' + (this.isEdit ? this.oriObj.ID : 0)
    },
    autoSaveHint () {
      if (!this.lastSaveTs) return ''
      if (!this.hasChangeNotSaveYet) return '所有變更已儲存至暫存'
      let s = Math.max(
        1,
        Math.ceil((new Date().getTime() - this.lastSaveTs) / 1000)
      )
      return `${s}秒前已暫存變更`
    }
  },
  methods: {
    submit () {
      if (!this.validateInput()) {
        return
      }
      this.isLoading = true

      // 上傳圖片
      this.loadingHint = '正在上傳圖片'
      this.uploadImages()
        .then(results => {
          this.loadingHint = '正在上傳資料'

          this.form.Contents = JSON.stringify(this.form.contentJsonArr)
          this.form.contentJsonArr = undefined

          let promise = this.isEdit
            ? this.$services.work.edit(this, this.form)
            : this.$services.work.add(this, this.form)
          promise
            .then(res => {
              let ok = res && res.data && res.data.status === 'ok'
              if (ok) this.onObjAddedit(res)
            })
            .catch(e => {
              console.error(e)
              alert(e)
            })
            .finally(() => {
              this.isLoading = false
            })
        })
        .catch(e => {
          this.isLoading = false
          console.error(e)
          alert(e)
          // recover form content json arr
          this.form.contentJsonArr = JSON.parse(this.form.Contents)
        })
    },
    uploadImages () {
      var promiseList = []
      // 確認封面
      if (
        this.form.newCoverImgBlob &&
        this.form.newCoverImgBlob instanceof Blob
      ) {
        let prefix = this.isEdit
          ? `work/${this.form.ID}/cover-`
          : `work/cover-${this.form.Title}-`
        let promise = this.$services.firebase
          .upload(this.form.newCoverImgBlob, prefix)
          .then(url => {
            this.$set(this.form, 'CoverImgUrl', url)
            this.$set(this.form, 'newCoverImgBlob', undefined)
            return url
          })
        promiseList.push(promise)
      }
      // 確認圖片
      for (let i in this.form.contentJsonArr) {
        let obj = this.form.contentJsonArr[i]
        if (!obj) continue
        if (obj.type === 'image' && obj.value.img instanceof Blob) {
          let prefix = this.isEdit
            ? `work/${this.form.ID}/`
            : `work/${this.form.Title}-`
          let promise = this.$services.firebase
            .upload(obj.value.img, prefix)
            .then(url => {
              this.$set(this.form.contentJsonArr[i].value, 'img', url)
              return url
            })
          promiseList.push(promise)
        }
      }
      return Promise.all(promiseList)
    },
    onObjAddedit (res) {
      localStorage.removeItem(this.cacheKey)
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$router.push({ name: 'work-list' })
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.work.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.work.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.work.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown work for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Title) {
        errMsg = '請輸入標題'
      }
      if (!this.form.CoverImageUrl) {
        errMsg = '請上傳封面圖片'
      } else if (!this.form.CoverImageThumbUrl) {
        errMsg = '封面圖片縮圖異常'
      }
      if (errMsg != null) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
        return false
      }

      if (errMsg != null) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    autoSave () {
      if (!this.hasChangeNotSaveYet) return
      this.hasChangeNotSaveYet = false

      this.form.Contents = JSON.stringify(this.form.contentJsonArr)

      let cache = JSON.stringify(this.form)
      localStorage.setItem(this.cacheKey, cache)

      this.lastSaveTs = new Date().getTime()
    }
  },
  created () {
    let id = parseInt(this.$route.params.id)
    if (id && id > 0) {
      let idx = this.$store.state.work.list.findIndex(o => o.ID === id)
      if (idx >= 0) {
        this.oriObj = this.$store.state.work.list[idx]
        this.form = JSON.parse(JSON.stringify(this.oriObj))
      } else {
        console.error(`unknown work for id ${id}`)
      }
    }

    let cache = localStorage.getItem(this.cacheKey)
    if (cache) {
      this.form = JSON.parse(cache)
      this.notification = this.$notify({
        message: '已載入暫存資料',
        duration: 0
      })
    }

    this.autoSaveTimer = setInterval(this.autoSave, 5000)
  },
  beforeDestroy () {
    clearInterval(this.autoSaveTimer)
    if (this.notification) this.notification.close()
    this.notification = null
  },
  watch: {
    form: {
      handler () {
        this.hasChangeNotSaveYet = true
      },
      deep: true
    }
  }
}
</script>

<style>
.el-tabs {
  height: 100%;
}
.el-tabs .el-tabs__content {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.el-tab-pane {
  max-width: 1030px;
}
</style>
<style scoped>
.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 120px;
}

.btn-upload {
  position: absolute;
  top: 26px;
  right: 20px;
}

.auto-save-hint {
  position: absolute;
  top: 32px;
  left: 32px;
  color: gray;
  font-size: 14px;
}
</style>
